// src/features/sales/components/SalesPurchaseDashboard.tsx
import React, { useState } from 'react'
import Tabs from '@shared/components/ui/Tabs'
import SkuCatalogPanel from './SkuCatalogPanel'
import BomPanel from './BomPanel'
import CreateWorkOrderPanel from './CreateWorkOrderPanel'
import WorkOrderList from './WorkOrderList'
import CreateSalesOrderPanel from './CreateSalesOrderPanel'
import SalesOrderList from './SalesOrderList'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

const TAB_LABELS = ['SKU Catalog', 'BOM', 'Production', 'Provisioning'];

export default function SalesPurchaseDashboard() {
  useDocumentTitle('Sales / Purchase');
  const [tab, setTab] = useState(TAB_LABELS[0]);

  return (
    <section className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-neutral-100">Sales / Purchase</h1>
      </div>

      <Tabs tabs={TAB_LABELS} activeTab={tab} onTabChange={setTab} />

      {tab === 'SKU Catalog' && (
        <div className="space-y-6">
          <SkuCatalogPanel />
        </div>
      )}

      {tab === 'BOM' && (
        <div className="space-y-6">
          <BomPanel />
        </div>
      )}

      {tab === 'Production' && (
        <div className="space-y-6">
          <CreateWorkOrderPanel />
          <WorkOrderList />
        </div>
      )}

      {tab === 'Provisioning' && (
        <div className="space-y-6">
          <CreateSalesOrderPanel />
          <SalesOrderList />
        </div>
      )}
    </section>
  )
}